import React from 'react';
import {Field} from 'redux-form/immutable';
import {CheckboxGroupField} from 'redux-form-antd'
import {
    required,
} from "../validDesc";
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};

const SseS4 = props => {
    const ans = '興   趣'
    const select_arr = [
        {
            value: '1',
            label: '電視電影'
        },
        {
            value: '2',
            label: '閱讀'
        },
        {
            value: '3',
            label: '登山'
        },
        {
            value: '4',
            label: '露營'
        },
        {
            value: '5',
            label: '旅行郊遊'
        },
        {
            value: '6',
            label: '美術'
        },
        {
            value: '7',
            label: '划船游泳'
        },
        {
            value: '8',
            label: '釣魚'
        },
        {
            value: '9',
            label: '國術'
        },
        {
            value: '10',
            label: '樂器演奏'
        },
        {
            value: '11',
            label: '歌唱'
        },
        {
            value: '12',
            label: '音樂欣賞'
        },
        {
            value: '13',
            label: '舞蹈'
        },
        {
            value: '14',
            label: '繪畫'
        },
        {
            value: '15',
            label: '集郵'
        },
        {
            value: '16',
            label: '打球'
        },
        {
            value: '17',
            label: '編織'
        },
        {
            value: '18',
            label: '下棋'
        },
        {
            value: '19',
            label: '養小動物'
        },
        {
            value: '20',
            label: '作物栽培'
        },
        {
            value: '21',
            label: '電腦'
        }
    ]
    return (
        <div>
            <Field {...formItemLayout} validate={required} component={CheckboxGroupField} options={select_arr} label={ans} name="sse_s4"
                   type="checkbox"/>
        </div>
    )
}

export default SseS4


// WEBPACK FOOTER //
// ./src/dashboards_redux/containers/TransferStudentContaioner/TransferStudentForm/SseS4.jsx